var render = function render(){var _vm=this,_c=_vm._self._c;return _c('titled-card',{class:_vm.b(),attrs:{"title":"Historial","count":_vm.filteredDeals.length,"icon":"mdi-history"}},[_c('div',{class:_vm.b('content')},[_c('deals-history',{attrs:{"deals":_vm.filteredDeals}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }